import React, { useCallback } from 'react'

import { useSelectedTrial } from 'src/features/auth/context'
import { useMirohaToast } from 'src/lib/chakra-theme/components/toast/use-miroha-toast'

import { EditModal } from './edit-modal'
import { update } from '../../../../../../../entities/template-folder/request'
import { useRequestState } from '../../../../../../../server/use-request-state'
import { useTemplateEntities } from '../../../template-entities-context'

const useSubmit = (templateFolderUid: string) => {
  const { selectedTrial } = useSelectedTrial()
  const trialUid = selectedTrial.uid

  const { requesting, errorMessage, requestDone, requestStarted } =
    useRequestState()
  const { upsertTemplateFolder } = useTemplateEntities()
  const toast = useMirohaToast()
  const request = useCallback(
    async (name: string) => {
      try {
        requestStarted()
        const res = await update({ trialUid, templateFolderUid, name })
        upsertTemplateFolder(res)
        toast({
          status: 'success',
          title: 'フォルダ名を編集しました',
        })
        requestDone()
      } catch (error) {
        toast({
          status: 'error',
          title: error.message,
        })
      }
    },
    [
      toast,
      upsertTemplateFolder,
      requestDone,
      requestStarted,
      templateFolderUid,
      trialUid,
    ],
  )

  return { request, requesting, errorMessage }
}

type Props = {
  v2: boolean
  templateFolderUid: string
  onClose: () => void
}

export const EditModalContainer: React.FC<Props> = props => {
  const { getTemplateFolder } = useTemplateEntities()
  const templateFolder = getTemplateFolder(props.templateFolderUid)
  const { request, requesting } = useSubmit(props.templateFolderUid)
  const onSubmit = useCallback(
    async (name: string) => {
      await request(name)
      props.onClose()
    },
    [props, request],
  )

  if (!templateFolder) return null

  return (
    <EditModal
      v2={props.v2}
      observationType={templateFolder.observationType}
      initialName={templateFolder.name}
      onClose={props.onClose}
      onSubmit={onSubmit}
      requesting={requesting}
    />
  )
}
